





<div class="forgot-password-container">
  <div class="card-wrapper">
    <div class="card">
      <div class="card-header">
        <div class="logo-container">
          <img src="assets/AivorLogo.png" alt="Aivor Logo" class="logo">
        </div>
        <h1 class="title">Forgot Password</h1>
        <p class="subtitle" *ngIf="!showTenantSelection">Enter your email to receive password reset instructions</p>
        <p class="subtitle" *ngIf="showTenantSelection">Select your organization to continue</p>
      </div>

      <div class="card-body">
        <form (submit)="onSubmit($event)" class="forgot-password-form" *ngIf="!showTenantSelection">
          <div class="form-group">
            <label for="email" class="form-label">Email Address</label>
            <input
              id="email"
              type="email"
              [(ngModel)]="email"
              name="email"
              class="form-control"
              placeholder="Enter your email"
              [disabled]="emailSubmitted"
              required>
          </div>

          <button type="submit" class="btn-submit" [disabled]="loading || !email">
            <span *ngIf="!loading">Continue</span>
            <span *ngIf="loading" class="spinner"></span>
          </button>

          <div *ngIf="errorMessage" class="alert alert-error">
            {{ errorMessage }}
          </div>

          <div *ngIf="successMessage" class="alert alert-success">
            {{ successMessage }}
          </div>
        </form>

        <!-- Tenant Selection -->
        <div *ngIf="showTenantSelection" class="tenant-selection">
          <div class="form-group">
            <label class="form-label">Select your organization</label>
            <div class="tenant-list">
              <!-- Debug info - will be removed later -->
              <div *ngIf="tenants.length > 0" class="debug-info" style="display: none;">
                <pre>{{ tenants | json }}</pre>
              </div>

              <div
                *ngFor="let tenant of tenants; let i = index"
                class="tenant-option"
                [class.selected]="selectedTenantId === tenant?.tenantId"
                (click)="selectedTenantId = tenant?.tenantId">
                {{ tenant?.tenantName || ('Organization ' + (i + 1)) }}
              </div>

              <div *ngIf="tenants.length === 0" class="no-tenants">
                No organizations found for this email.
              </div>
            </div>
          </div>

          <div class="button-group">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="goBack()"
              [disabled]="loading">
              Back
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="onTenantSelect()"
              [disabled]="loading || selectedTenantId === null">
              <span *ngIf="!loading">Send Reset Email</span>
              <span *ngIf="loading" class="spinner"></span>
            </button>
          </div>
        </div>

        <div class="form-footer">
          <button type="button" class="btn btn-link" (click)="goToLogin()">Back to Login</button>
        </div>
      </div>
    </div>
  </div>
</div>

